/*
 * WARNING: DEPRECATED
 *
 * Used on the sell form for displaying a remaining
 * character count for listing Titles.
 */
(function($) {
  $.fn.extend({
    limit: function(limit, element) {
      var interval, f;
      var self = $(this);
      $(this).focus(function() {
        interval = window.setInterval(substring, 100)
      });
      $(this).blur(function() {
        clearInterval(interval);
        substring()
      });

      function substring() {
        var val = $(self).val();var length = val.length;
        if(length > limit) {
          $(self).val($(self).val().substring(0,limit));
        }

        if (typeof element != "undefined") {
          if($(element).html() != limit-length) {
            $(element).html((limit-length<=0)?'0':limit-length);
          }
        }
      }

      substring()
    }
  })
})(jQuery)
